// Shipments index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    systems: {
      items: [],
      count: '',
      entity: {},
    },
    drafts: {
      items: [],
      count: '',
      entity: {},
    },
    unapproved: {
      items: [],
      count: '',
      entity: {},
    },
    items: [],
    count: '',
    entity: {},
    ids_of_all_records: [],
    shipment: {},
    singleShipment: null,
    senders: [],
    shippers: [],
    palleteTypes: {},
    additionalFileTypes: {},
    waybillPrinters: [],
    dangerousGoodsOptions: [],
    dangerousGoodsServices: [],
    dangerousGoodsTypes: {},
    dangerousGoodsPackingTypes: [],
    parcelTypes: null,
    // end of day
    endOfDay: null,
    eodShipments: {
      items: [],
      entity: [],
      count: '',
    },
    endOfDayList: {
      items: [],
      entity: [],
      count: '',
    },
    // CONSOLIDATION
    consolidationsList: {
      items: [],
      entity: [],
      count: '',
    },
    consolidationShipments: {
      items: [],
      entity: [],
      count: '',
    },
    consolidation: {
      consolidation: null,
      barcode: null,
      waybill: null,
      cons_email_status: null,
      cons_product_types: null
    },
    // END CONSOLIDATION
    shipmentEditMode: false,
    shipmentCompareTemplate: {
      pickupTimeUntil: '',
      pickupTimeFrom: '',
      pickupDriverNote: '',
      isReturn: false,
      droppointNo: '',
      shipmentType: '',
      draftShippmentId: '',
      shippingAgentName: '',
      errorStatuses: [],
      inverted: false,
      shippingDate: '',
      // Shipper
      foreignShipper: false,
      shipper: '',
      // Sender data
      fromAddress: {
        address_1: '',
        address_2: '',
        country_id: '',
        post_code: '',
        city: '',
        state: '',
      },
      fromData: {
        reference: '',
        company: '',
        attention: '',
        email: '',
        phone: {
          number: '',
          country: '',
        },
      },
      // Customer data
      toAddress: {
        address_1: '',
        address_2: '',
        country_id: '',
        post_code: '',
        city: '',
        state: '',
      },
      toData: {
        company: '',
        reference: '',
        attention: '',
        email: '',
        phone: {
          number: '',
          country: '',
        },
      },
      // GOODS
      activeGoodsTypes: [],
      storeShipmentPackages: [],
      defaultPackageBlocks: {
        parcel: {
          goodsTypeName: 'Parcel',
          goodsType: 1,
          colli: 1,
          description: '',
          parcelType: '',
          packagingName: '',
          colliWeight: {
            value: '',
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: '',
              disabled: false,
            },
            height: {
              value: '',
              disabled: false,
            },
            length: {
              value: '',
              disabled: false,
            },
            dimensionsType: '',
          },
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                value: '',
                unit: 'kg',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          allPackedInOne: '',
          packingType: '',
          iataRadioactive: '',
          iataLimitations: '',
          iataAdditionalInfo: '',
          packingTypeOption: 2,
          isOverpack: 0,
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ]
        },
        document: {
          goodsTypeName: 'Document',
          goodsType: 2,
          colli: 1,
          parcelType: '',
          packagingName: '',
          colliWeight: {
            value: '',
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: '',
              disabled: false,
            },
            height: {
              value: '',
              disabled: false,
            },
            length: {
              value: '',
              disabled: false,
            },
            dimensionsType: '',
          },
        },
        pallet: {
          goodsTypeName: 'Pallet',
          goodsType: 3,
          colli: 1,
          description: '',
          palleteType: 'Euro pallet - 120cm x 80cm',
          colliWeight: {
            value: '',
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: '',
              disabled: false,
            },
            height: {
              value: '',
              disabled: false,
            },
            length: {
              value: '',
              disabled: false,
            },
            dimensionsType: 'cm',
          },
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          pallet_stackable_type: 'stackable',
          palletSpace: '',
          // stackablePallets: true,
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                value: '',
                unit: 'kg',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          packingType: '',
          packingTypeOption: 2,
          isOverpack: 0,
          iataRadioactive: '',
          iataLimitations: '',
          iataAdditionalInfo: '',
          allPackedInOne: '',
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ]
        },
        load: {
          goodsTypeName: 'Load',
          goodsType: 4,
          colli: 1,
          description: '',
          parcelType: 0, // Unknown packaging
          packagingName: '',
          colliWeight: {
            value: '',
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: '',
              disabled: false,
            },
            height: {
              value: '',
              disabled: false,
            },
            length: {
              value: '',
              disabled: false,
            },
            dimensionsType: '',
          },
          cubicMeter: '',
          loadMeter: '',
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                value: '',
                unit: 'kg',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          packingType: '',
          packingTypeOption: 2,
          isOverpack: 0,
          iataRadioactive: '',
          iataLimitations: '',
          iataAdditionalInfo: '',
          allPackedInOne: '',
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ]
        },
      },
      cleanShipmentCompareTemplate: {},
      // PAYMENT
      customsData: {
        customsAddress: {
          address_1: '',
          address_2: '',
          country_id: '',
          post_code: '',
          city: '',
          state: '',
        },
        customsAddressData: {
          company: '',
          attention: '',
          email: '',
          reference: '',
          phone: {
            number: '',
            country: '',
          },
        },
        goods_incoterm: 'DAP',
        duty_paid_by: '1',
        duty_payer_account_no: '',
        freight_paid_by: '1',
        freight_payer_account_no: '',
        freight_payer_id: '',
      },
      // TAGS
      custom_tag_json: [],
      // SERVICES
      apiFeeIds: [],
      apiActiveServices: null,
      selectedProduct: '',
      additionalServicesData: null,
    },
  },
  actions,
  mutations,
  getters,
};
